import { render, staticRenderFns } from "./TypeFilesTransfer.vue?vue&type=template&id=3f2f868b&scoped=true"
import script from "./TypeFilesTransfer.vue?vue&type=script&lang=js"
export * from "./TypeFilesTransfer.vue?vue&type=script&lang=js"
import style0 from "./TypeFilesTransfer.vue?vue&type=style&index=0&id=3f2f868b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f868b",
  null
  
)

export default component.exports